import React, { useEffect } from "react";
import { useDispatch, useSelector, useStore } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { toast } from "react-toastify";
import Button from "../../Common/FormElements/Button/Button";
import { fetchProject } from "../../../REDUX/actions/appProjects";

// Socket "project:event" (API utils/advisorNotify): a customer acted on one of
// the advisor's projects in the app. Raw i18n keys.
const TITLES = {
  quote_accepted: "{{name}} accepted quote no. {{number}}",
  quote_refused: "{{name}} refused quote no. {{number}}",
  quote_new_requested: "{{name}} asks for a new quote",
};

const ProjectEventToast = ({ event, onOpen }) => {
  const { t } = useTranslation("common");
  const navigate = useNavigate();
  const time = moment(event.at).format("HH:mm");
  return (
    <div className="d-flex flex-column gap-2">
      <span className="f14 sBold text-ultraBlack">
        {t(TITLES[event.kind], { name: event.customerName, number: event.quoteId })}
      </span>
      <span className="f12 text-brightGrey">
        {event.emailed
          ? t("Today {{time}} · An e-mail has been sent to you", { time })
          : time}
      </span>
      <div>
        <Button
          onClick={() => {
            navigate("/clients-app", {
              state: { projectId: event.projectId, projectTab: "Quote" },
            });
            onOpen();
          }}
        >
          {t("Open project No. {{number}}", { number: event.projectNumber })}
        </Button>
      </div>
    </div>
  );
};

/**
 * N1 — live toast (bottom-right) when a customer accepts / refuses a quote or
 * asks for a new one; also refreshes the project list and its counters.
 */
const ProjectEventToasts = () => {
  const dispatch = useDispatch();
  const store = useStore();
  const { socket } = useSelector((state) => state.socketReducer) ?? {};

  useEffect(() => {
    if (!socket) return;
    const onEvent = (event) => {
      if (!TITLES[event?.kind]) return;
      dispatch({ type: "PROJECTS_TOUCHED" });
      // The project sheet open on that project shows the new quote state.
      const { currentProject } = store.getState().appProjectsReducer;
      if (currentProject?.id === event.projectId) {
        dispatch(fetchProject(event.projectId));
      }
      // The id is known once toast() returns; the button dismisses its own toast.
      let toastId;
      const dismiss = () => toast.dismiss(toastId);
      toastId = toast(<ProjectEventToast event={event} onOpen={dismiss} />, {
        position: "bottom-right",
        autoClose: false,
        closeOnClick: false,
      });
    };
    socket.on("project:event", onEvent);
    return () => socket.off("project:event", onEvent);
  }, [socket, dispatch, store]);

  return null;
};

export default ProjectEventToasts;
